import { message } from "antd";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import PurchaseOrderService from "../services/PurchaseOrder/PurchaseOrderService";
import { PURCHASE_ORDER_ROOT } from "../pages/RouteConstants";
import ConfirmDeleteButton from "../common/actions/ConfirmDeleteButton";
import { queryClient } from "../react-query-client";

const PurchaseOrderDelete = ({ purchaseOrderId, ...props }) => {
  const navigate = useNavigate();
  const { mutate } = useMutation({
    mutationFn: async () => await PurchaseOrderService.deletePurchaseOrder(purchaseOrderId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["purchaseOrderListTabCounts"] });
      await queryClient.invalidateQueries({ queryKey: ["purchaseOrderList"] });
      navigate(PURCHASE_ORDER_ROOT, { replace: true });
      message.success("PO deleted successfully!");
    },
    onError: async (error) => {
      message.error(`Failed to delete PO. ${error.response?.data?.message}.`);
    },
  });

  return (
    <>
      <ConfirmDeleteButton
        title={<>
          You are about to delete this PO.
          <br />
          This action will also delete any documents linked to this PO and can not be reversed.
          <br />
          Please confirm if you wish to proceed.
        </>}
        className="button-danger"
        onConfirm={mutate}
        okText={"OK"}
        cancelText={"Cancel"}
        {...props}
        type="primary">
        Delete
      </ConfirmDeleteButton>
    </>
  );
};

export default PurchaseOrderDelete;